import { computed, Ref } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { TypeSupportingCustomFieldValues } from '@/gql/graphql'
import { PER_PAGE_MAXIMUM } from '@/utils/constants'
import { SupplierSharedCustomFieldsQuery } from '@/components/Fieldable/graphql/queries'

export default function useSupplierSharedCustomFields(
  viewerAccount: string,
  supplierId: Ref<string | undefined>,
  appliesTo?: TypeSupportingCustomFieldValues[],
  first: number = PER_PAGE_MAXIMUM,
) {
  const { result, loading } = useQuery(
    SupplierSharedCustomFieldsQuery,
    () => ({
      viewerAccount,
      supplier: supplierId.value!,
      appliesTo,
      first,
    }),
    () => ({
      clientId: 'publicApi',
      enabled: !!supplierId.value,
    }),
  )

  const fields = computed(
    () =>
      result?.value?.supplierSharedCustomFields?.data.map((field) => ({
        ...field,
      })) ?? [],
  )

  return {
    fields,
    loading,
  }
}
